import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_HISTORICAL_DATA]: (state, item) => addOrUpdateItem(state, item),
}
